import {InjectionToken} from '@angular/core'
import {OrderStatusEmbeddedService} from '@service/orders/status/order-status.embedded.service'
import {OrderStatusService} from '@service/orders/status/order-status.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `OrderStatusService`.
 *
 * @description
 * Devuelve `OrderStatusEmbeddedService` en modo embebido y
 * `OrderStatusService` en modo standalone. `OrderStatusService` maneja
 * el ciclo de vida del estado de un pedido (borrador, enviado, aceptado,
 * rechazado...) y las transiciones permitidas.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `OrderStatusService`.
 */
export function providerOrderStatusFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new OrderStatusEmbeddedService() : new OrderStatusService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `OrderStatusService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerOrderStatusFactory}.
 */
export const OrderStatusServiceToken = new InjectionToken<OrderStatusService>('UMService')
